import useEditCharacterCampaignNote from '../composables/useEditCharacterCampaignNote'
//---------------------------------------
// edit character campaign notes harness
//---------------------------------------
export default async function useEditCharacterCampaignNotesHarness(changed_campaign_notes) {
  console.log('---------------------------------------')
  console.log('IN useEditCharacterCampaignNotesHarness')
  //----------------------------------------------------
  // manages all character campaign note updates (CRUD)
  //----------------------------------------------------
  //----------------------------------------------
  // create promise for each campaign note update
  //----------------------------------------------
  const promises = changed_campaign_notes.map((r) => {
    console.log('IN useEditCharacterCampaignNotesHarness - PROCESSING CAMPAIGN NOTE:', r)
    //-------------------
    // call api function
    //-------------------
    return useEditCharacterCampaignNote(r)
  })
  //------------------------------------------------------------
  // wait for all updates to complete - let errors propagate up
  //------------------------------------------------------------
  // const results = await Promise.all(promises)
  await Promise.all(promises)
  //-----------------------------
  // optionally return responses
  //-----------------------------
  // if (returnResponses) return results
  // return results
  //----------------------------------------------
  // else no response (caller awaited completion)
  //----------------------------------------------
  return
}
